export default {
  MARKETING: 'MARKETING',
  PAY_IN_FULL: 'PAY_IN_FULL',
}
